import { render, staticRenderFns } from "./BaseExpired.vue?vue&type=template&id=86da9310&"
import script from "./BaseExpired.vue?vue&type=script&lang=js&"
export * from "./BaseExpired.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports